import React, { useEffect } from "react";

import { useAuth } from "./backend/useAuth";
import Loader from "./utils/loader";
import Routes from "./routes";

const App = () => {
  const { tokenLogin } = useAuth();
  useEffect(() => {
    tokenLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Routes />
      <Loader />
    </>
  );
};

export default App;
